import React from "react";
import {styles} from "./LoginPageStyle";
import { css } from "aphrodite/no-important";
import axios from "axios";
import { Api } from "src/core/api";
import { JsonConvert } from "json2typescript";
import { LoginResponse } from "../models/LoginResponse";
import { Application } from "src/core/application";

class LoginPageState {
    public readonly username: string = "" ;
    public readonly password: string = "";
    public is_remember_me: boolean = false;
}

export class LoginPage extends React.Component<any,LoginPageState> {

    constructor(props:any){
        super(props);
        this.state = new LoginPageState();
    }
    
    public render() {
        return (
            <div id="content" className={css(styles.content)}  >
                <form onSubmit={this.onSubmit} className={css(styles.loginContainer)}>
                    <div>
                        <div>
                            User name:
                        </div>
                        <input type="text" name="username" value={this.state.username} onChange={this.onUserNameChange} />
                    </div>

                    <div>
                        <div>
                            Password:
                        </div>
                        <input type="password" name="password" value={this.state.password}  onChange={this.onPasswordChange}/>
                    </div>

                    <div className={css(styles.submitButton)} >
                        <input type="submit" value="Submit" />                
                    </div>

                </form>
            </div>
        );
    }

    private onSubmit = (event: any) => {
        event.preventDefault();
        const data = {
            username: this.state.username,
            password: this.state.password
        }
        axios.post(`${Api.getEndPoint()}/login`,data).then((res)=>{          
            const jsonConvert = new JsonConvert();
            const loginResponse = jsonConvert.deserialize(res.data, LoginResponse);
            Application.login(loginResponse);
            this.props.history.push("/");
        }).catch((error)=> {
            //handle this error
            console.log(error);
        })
    }

    private onUserNameChange = (event: any) => {
        const newState = {...this.state, username: event.target.value}
        this.setState(newState);
    }

    private onPasswordChange = (event: any) => {
        const newState = {...this.state, password: event.target.value}
        this.setState(newState)
    }

}


// WEBPACK FOOTER //
// ./src/pages/LoginPage.tsx